import { createContext, useContext, useState, useCallback, ReactNode } from 'react';

interface PollingContextType {
  isPollingEnabled: boolean;
  enablePolling: () => void;
  disablePolling: () => void;
}

const PollingContext = createContext<PollingContextType | undefined>(undefined);

export function PollingProvider({ children }: { children: ReactNode }) {
  const [isPollingEnabled, setIsPollingEnabled] = useState(true);

  const enablePolling = useCallback(() => {
    setIsPollingEnabled(true);
  }, []);

  const disablePolling = useCallback(() => {
    setIsPollingEnabled(false);
  }, []);

  return (
    <PollingContext.Provider value={{ isPollingEnabled, enablePolling, disablePolling }}>
      {children}
    </PollingContext.Provider>
  );
}

export function usePolling() {
  const context = useContext(PollingContext);
  if (!context) {
    throw new Error('usePolling must be used within PollingProvider');
  }
  return context;
}
